"use strict";

require("core-js/modules/es.object.assign.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _models = require("../../models");
var _constants = require("../../../utils/constants");
var _CubeModel = _interopRequireDefault(require("../Models/CubeModel"));
var _functions = require("../../../utils/functions");
const _excluded = ["hideCirculation", "isDisabled"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const ItemPipes = _ref => {
  let {
      hideCirculation = false,
      isDisabled = false
    } = _ref,
    p = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("group", _extends({
    position: [0, 0, 0]
  }, p), /*#__PURE__*/_react.default.createElement("group", null, /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    scale: [1, 1, 14],
    position: [-10, 11, -8],
    rotation: [Math.PI / 2, 0, 0],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.chilledWater)
  }), /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
    position: [-10, 11, -8],
    rotation: [-Math.PI / 2, 0, -Math.PI],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.chilledWater)
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    scale: [1, 1, 1.6],
    position: [-9, 10, -8],
    rotation: [0, -Math.PI / 2, 0],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.chilledWater)
  }), /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
    position: [-1, 10, -8],
    rotation: [0, -Math.PI / 2, 0],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.chilledWater)
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    scale: [1, 1, 0.9],
    position: [0, 10, -9],
    rotation: [0, 0, 0],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.chilledWater)
  }), /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, 10, -13.75],
    args: [1, 1, 0.5],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.chilledWater)
  })), /*#__PURE__*/_react.default.createElement("group", {
    position: [0, 0, 0]
  }, /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    scale: [1, 1, 10],
    position: [-10, 31, -6],
    rotation: [Math.PI / 2, 0, 0],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.hotWater)
  }), /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
    position: [-10, 31, -6],
    rotation: [-Math.PI / 2, 0, -Math.PI],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.hotWater)
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    scale: [1, 1, 1.6],
    position: [-9, 30, -6],
    rotation: [0, -Math.PI / 2, 0],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.hotWater)
  }), /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
    position: [-1, 30, -6],
    rotation: [0, -Math.PI / 2, 0],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.hotWater)
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    scale: [1, 1, 1.3],
    position: [0, 30, -7],
    rotation: [0, 0, 0],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.hotWater)
  }), /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, 30, -13.75],
    args: [1, 1, 0.5],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.hotWater)
  })), /*#__PURE__*/_react.default.createElement("group", {
    position: [0, 0, 0]
  }, /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    scale: [1, 1, 7.6],
    position: [-10, 21, -4],
    visible: !hideCirculation,
    rotation: [Math.PI / 2, 0, 0],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.circulation)
  }), /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
    position: [-10, 21, -4],
    visible: !hideCirculation,
    rotation: [-Math.PI / 2, 0, -Math.PI],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.circulation)
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    scale: [1, 1, 1.6],
    position: [-9, 20, -4],
    visible: !hideCirculation,
    rotation: [0, -Math.PI / 2, 0],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.circulation)
  }), /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
    position: [-1, 20, -4],
    visible: !hideCirculation,
    rotation: [0, -Math.PI / 2, 0],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.circulation)
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    scale: [1, 1, 1.7],
    position: [0, 20, -5],
    rotation: [0, 0, 0],
    visible: !hideCirculation,
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.circulation)
  }), /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
    position: [-10, 60, -5],
    visible: !hideCirculation,
    rotation: [0, Math.PI, Math.PI / 2],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.circulation)
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    scale: [1, 1, 0.2],
    position: [-10, 60, -5],
    rotation: [0, 0, 0],
    visible: !hideCirculation,
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.circulation)
  }), /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    visible: !hideCirculation,
    position: [0, 20, -13.75],
    args: [1, 1, 0.5],
    highlightsType: (0, _functions.checkDisabledHighlight)(isDisabled, _constants.pipesTypes.circulation)
  })));
};
var _default = exports.default = ItemPipes;